import { createFileRoute, Navigate, Outlet } from "@tanstack/react-router";
import InactiveNotice from "@/components/tutor/inactive-notice";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import GradCapLoader from "@/components/ui/grad-cap-loader";
import { useAuth } from "@/services/auth/auth-context";
import { useMyStaffData } from "@/services/entities/use-staff";

export const Route = createFileRoute("/tutordashboard/_layout")({
  component: RouteComponent,
});

function RouteComponent() {
  const { authUser, isTutor, isLoading: authLoading } = useAuth();
  const { staff: tutor, isLoading, error } = useMyStaffData();

  if (isLoading || authLoading) {
    return <GradCapLoader />;
  }

  if (!authUser) {
    return <Navigate to="/login" search={{ from: "/tutordashboard" }} />;
  }

  if (tutor?.staff_id && !tutor.is_active) {
    return <InactiveNotice />;
  }

  // logged in, is a tutor, and has a tutor id
  if (authUser && isTutor) {
    return <Outlet />;
  }

  if (error && isTutor) {
    return (
      <div className="container mx-auto px-4 py-8">
        <Alert className="mb-4">
          <AlertTitle>Data Not Found</AlertTitle>
          <AlertDescription>
            The system cannot find your tutor data. Most likely, your tutor profile has not been
            created by an administrator.
          </AlertDescription>
        </Alert>
      </div>
    );
  }

  return <Navigate to="/unauthorized" />;
}
